var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(!_vm.loaded)?_c('div',{staticClass:"text-center"},[_vm._v("No Data")]):_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series,"labels":_vm.labels,"height":"200"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }